import { Container, Row, Col, Button, Card } from "react-bootstrap";
import { FaHome, FaExclamationTriangle } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const NotFound = () => {
  const navigate = useNavigate();
  const handleBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate("/");
    }
  };

  return (
    <Container
      fluid
      className="vh-100 d-flex align-items-center justify-content-center bg-light"
    >
      <Row className="text-center">
        <Col>
          <Card className="p-5 shadow-sm border-0 rounded-4 fade-in">
            <FaExclamationTriangle
              size={80}
              className="text-warning mb-1 text-center w-100"
            />

            <h1 className="display-1 fw-bold">404</h1>

            <h4 className="mb-2">Page Not Found</h4>

            <p className="text-muted mb-4" style={{ maxWidth: 420 }}>
              The page you are looking for doesn’t exist or may have been moved.
            </p>

            <Button
              variant="primary"
              className="px-4 hstack gap-2 rounded-1 mx-auto"
              style={{ fontSize: 13 }}
              onClick={handleBack}
            >
              <FaHome />
              Back to Page
            </Button>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default NotFound;
